<template>

   <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'الحضور والغياب'" :to="{name: 'absences'}"> الحضور والغياب</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'absences.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                          بيانات الحضور والغياب</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="store()">
                                    <div class="row">
                                      
                                       <div class="col-md-4" :style="user.role == 'teacher' ? 'display: none;' : ''">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة الدراسية</label>
                                            <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroups" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4" :style="user.role == 'teacher' ? 'display: none;' : ''">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصف الدراسى</label>
                                           
                                            <treeselect :options="groups" v-model="data.form.group_id" @select="getLessons" :multiple="false" />

                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4" :style="user.role == 'teacher' ? 'display: none;' : ''">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الحلقة</label>
                                            <treeselect :options="lessons" :auto-load-root-options="true" v-model="data.form.lesson_id" @select="getTeachers" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['lesson_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['lesson_id']">
                                                  {{ getErrors['lesson_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-12" v-if="user.role == 'admin'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المعلم</label>
                                            <treeselect :options="teachers" :auto-load-root-options="true" v-model="data.form.teacher_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['teacher_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['teacher_id']">
                                                  {{ getErrors['teacher_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div :class="'col-md-' + (user.role == 'admin' ? '12' : '6')">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">التاريخ</label>
                                            <date-picker v-model="data.form.date_and_time" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['date_and_time'] ? 'display: block' : 'display: none;'"  v-if="getErrors['date_and_time']">
                                                  {{ getErrors['date_and_time'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-12 table-responsive">
                                        <!-- <a href="#" @click.prevent="addStudent" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-plus">إضافة طالب </a> -->

                                        <table class="table table-bordered">
                                          <thead>
                                            <tr>

                                              <th>الطالب</th>
                                              <th>الغياب</th>
                                               <!-- <th>#</th> -->
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr v-for="(st, k) in data.form.students" :key="k">

                                              <td v-if="data.form.students[k]">
                                                <h6>{{st.student_name}}</h6>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.student_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.student_id']">
                                                      {{ getErrors['students.'+k+'.student_id'][0] }}
                                                </div>
                                              </td>
                                              <td v-if="data.form.students[k]">
                                                <input type="radio" v-model="data.form.students[k].type" value="presence"> حضور
                                                <input type="radio" v-model="data.form.students[k].type" value="absence"> غياب
                                                <input type="radio" v-model="data.form.students[k].type" value="delay"> تأخير
                                                <input type="radio" v-model="data.form.students[k].type" value="excuse"> استأذان
                                               
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.type'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.type']">
                                                      {{ getErrors['students.'+k+'.type'][0] }}
                                                </div>
                                              </td>
<!--                                          
                                              <td>
                                                <a href="#" class="btn btn-danger" v-if="k != 0" @click.prevent="deleteFromStudent(st)">X</a>
                                              </td> -->
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>



                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'absences'}">
                                      <span>رجوع</span>
                                    </router-link>

                                   </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
      isExist: 1,
      trans: {},
      gotData: false,
      data: {
        checkerExit: 0,
        form: {
          teacher_id: '',
          lesson_id: '',
          stage_id: '',
          group_id: '',
          date_and_time: '',
          students: [{

          student_id: '',
          student: '',
          stOptions: [],
          type: 'presence',
          }],
        },
        permissions: [],
        isRequested: false,
        errors: {},
        paginated: {},
        allSelected: false,
      },
      lessons: [],
      groups: [],
      stages: [],
      teachers: [],
      sura: []
    };
  },
  created() {
    this.getRequirement();
  },
  methods: {
    resetForm(){
      this.data.form = {
          teacher_id: '',
          lesson_id: '',
          group_id: '',
          stage_id: '',
          date_and_time: '',
          students: [{

          student_id: '',
          student: '',
          stOptions: [],
          type: 'presence',
          }],
        };
    },
    store(){
      if(this.isExist){
        this.sweetAlert('من فضلك تأكد من البيانات وحاول مرة اخرى', 'error');
        return;
      }
      this.data.isRequested = true;
      this.$baseApi.post('/absences/absences', this.data.form).then((response) => {
        if (response.data.code === 200) {
          localStorage.setItem('flash_message', response.data.messages[0]);
          this.sweetAlert(response.data.messages[0]);
          router.push('/absences');
        }
      }).catch((error) => {
        this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
        this.data.isRequested = false
      })
    },
    deleteFromStudent(data){
      this.data.form.students.splice(this.data.form.students.indexOf(data), 1);
    },
    addStudent(){
      this.data.form.students.push({
          student_id: '',
          student: '',
          stOptions: [],
          type: '',
      })
    },
    getTeachers(val){
      this.data.form.teacher_id = '';
      this.data.form.students   = [];
      if(this.user.role == 'teacher'){
        this.data.form.teacher_id = this.user.teacher_id;
        return;
      }
      this.getStudents(val);
      this.$baseApi.get('/absences/absences/create?l=' + val.id).then((response)=>{
            if(response.data.code == 200){
               this.teachers = response.data.data.teachers;
              if(this.user.role != 'teacher'){
               for (let index = 0; index < this.teachers.length; index++) {
                this.data.form.teacher_id = this.teachers[index].id;
                
               }
              }

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
    },
    getRequirement(){
          this.$baseApi.get('/absences/absences/create?basic_pluck=1').then((response)=>{
            if(response.data.code == 200){
               this.stages  = response.data.data.stages;
               this.groups  = response.data.data.groups;
               this.lessons  = response.data.data.lessons;
               this.teachers = response.data.data.teachers;
               
               if(this.user.role == 'teacher'){
                  this.data.form.teacher_id = this.user.teacher_id;
                
                  if(this.stages){
                    for (let index = 0; index < this.stages.length; index++) {
                      let element = this.stages[index];
                      this.data.form.stage_id = element.id;
                      this.getGroups({id: element.id});
                    }
                  }
               }

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getGroups(val){
         this.$baseApi.get('/absences/absences/create?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
               if(this.user.role == 'teacher'){
                
                  if(this.groups){
                    for (let index = 0; index < this.groups.length; index++) {
                      let element = this.groups[index];
                      this.data.form.group_id = element.id;

                      this.getLessons({id: element.id});
                    }
                  }
               }
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getLessons(val){
         this.$baseApi.get('/absences/absences/create?option=lesson&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.lessons;
              if(this.user.role == 'teacher'){
                if(this.lessons){
                    for (let index = 0; index < this.lessons.length; index++) {
                      let element = this.lessons[index];
                      this.data.form.lesson_id = element.id;

                      this.getStudents({id: element.id}, true);
                    }
                }
              }
               
               
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getStudents(val, type = false){
        this.data.form.students = [{

        student_id: '',
        student: '',
        stOptions: [],
        type: 'presence',
        }],
         this.$baseApi.get('/absences/absences/create?option=student&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.data.form.students = response.data.data.students;
               this.gotData = type;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      checkerExit(){
        this.$baseApi.get('/absences/absences/create?option=checker&lesson='+this.data.form.lesson_id + '&date=' + this.data.form.date_and_time).then((response)=>{
            if(response.data.code == 200){
               this.isExist = 0;
            }
        }).catch((error) => {
          this.isExist = 1;
          this.sweetAlert(error.response.data.errors[0], 'error');
        });
      },

  loadOptions(search, key) {
    if(this.data.form.lesson_id == ''){
      this.sweetAlert('لا يمكنك اختيار طالب قبل اختيار الحلقة', 'warning');
      return;
    }
    if(search == ''){
      this.data.form.students[key].stOptions = [];
      return;
    }
      this.$baseApi.get('/absences/absences/create?student=' + search + '&lesson=' + this.data.form.lesson_id).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].stOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
  }

  },
  computed: {
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
  watch: {
    'data.form.lesson_id': function (val) {
      
      if(this.user.role == 'teacher' && this.gotData){
        this.getStudents({id: val});
      }
    },
    'data.form.date_and_time': function (newVal, oldVal){
         this.checkerExit();
     }
  }
};
</script>
<style>
.role-box {
  border-radius: 6px;
  box-shadow: 1px 1px 4px 0 #0000004a;
  padding: 11px;
}

.role-box h5 {
  text-align: center;
  border-bottom: 1px solid #8080808c;
}

.role-selected {
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 #00000042;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 11px;
}
</style>
